import React from "react";

export function EntityHeader({
  title,
  chip,
  accent,
  actionSlot
}: {
  title: string;
  description?: string;
  chip: string;
  accent: "blue" | "rose" | "sky";
  actionSlot?: React.ReactNode;
}): JSX.Element {
  return (
    <section className="tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white tw-p-5">
      <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
        {actionSlot ? <div className="tw-w-full">{actionSlot}</div> : null}
      </div>
    </section>
  );
}
